<div class="row">
  <strong>Alert Recipient Emails</strong>
</div>
<div class="row">
  <div class="col">
    <p-table [totalRecords]="emailAddresses?.length" #dt [value]="emailAddresses" styleClass="p-datatable-striped p-datatable-responsive-eca"
             [scrollable]="emailAddresses?.length > 5" scrollHeight="500px"
             [globalFilterFields]="['emailAddresses.personName', 'emailAddresses.email']">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 25%;" pSortableColumn="personName">
            Person Name
            <p-sortIcon field="personName"></p-sortIcon>
          </th>
          <th style="width: 40%;" pSortableColumn="email">
            Email Address
            <p-sortIcon field="email"></p-sortIcon>
          </th>
          <th style="font-weight: bold; width: 10%">
            Action
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-email style="margin: 15px;">
        <tr>
          <td>
            <div class="text-left">
              {{email.personName}}
            </div>
          </td>
          <td>
            <div class="text-left">
              {{email.email}}
            </div>
          </td>
          <td>
            <div class="text-center">
              <app-eca-row-menu (viewBtnClicked)="removeEmailClick(email)"
                                viewBtnText="Remove"
                                [rowMenuItems]="rowMenuItems"
                                [contextItem]="email.companySettingsId">
              </app-eca-row-menu>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
